export default {
      id: "star-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#star",
      toString: function () {
        return this.url;
      }
    }